"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CFG = {
    spinnerTpl: '<span class="btn-spinner"></span>',
    disableBtn: true,
    btnLoadingClass: 'is-loading',
    handleCurrentBtnOnly: false,
    minDuration: false,
    CLICK_EVENT: 'click',
};
//# sourceMappingURL=default-promise-btn-config.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular2-promise-buttons/dist/default-promise-btn-config.js
// module id = ../../../../angular2-promise-buttons/dist/default-promise-btn-config.js
// module chunks = vendor